import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select as MUISelect,
} from "@mui/material";
import React from "react";
import { useLocation } from "react-router";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
export default function Select(props) {
  const location = useLocation();
  const {
    name,
    label,
    value,
    onChange,
    optionText,
    optionValue,
    error = null,
    option,
    ...rest
  } = props;
  return (
    <FormControl fullWidth {...(error && { error: true })}>
      <InputLabel size="small">{label}</InputLabel>
      <MUISelect
        name={name}
        value={value}
        label={label}
        onChange={onChange}
        MenuProps={MenuProps}
        {...rest}
      >
        {option.map((item, key) => {
          return location?.pathname === "/manage-Apis/add-api" ? (
            <MenuItem
              key={key}
              value={item[optionValue]}
            >{`${item[optionValue]} ${item[optionText]}`}</MenuItem>
          ) : (
            <MenuItem key={key} value={item[optionValue]}>
              {item[optionText]}
            </MenuItem>
          );
        })}
      </MUISelect>
      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
}
